// components/ModalWrapper.js
"use client";

import { useEffect } from "react";
import Modal from "react-modal";

export default function ModalWrapper({
  isOpen,
  onClose,
  children,
  style,
  label,
}) {
  // useEffect(() => {
  //   Modal.setAppElement("#__next"); // required for accessibility
  // }, []);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={style}
      contentLabel={label || "Modal"}
    >
      {children}
    </Modal>
  );
}
